import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CompliancePage } from './compliance.page';
import { MainComplianceComponent } from './components/main-compliance/main-compliance.component';

const routes: Routes = [
  {
    path: '',
    component: MainComplianceComponent,
    children: [
      {
        path: '',
        component: CompliancePage,
      },
      { path: '**', redirectTo: '' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CompliancePageRoutingModule {}
